import React from 'react';
import PropTypes from 'prop-types';
import { LandPrice as LandPriceIcon } from 'bvt-icon';
import { BaseCard } from '@bvt-shared/component/BaseCard';
import './CardLandPrice.scss';

const LandPriceSidebar = (props) => {
  return (
    <div className='feature-griana LandPrice--sidebar'>
      <svg height='9.375rem' viewBox='0 0 270 150' width='16.875rem'>
        <defs>
          <filter
            filterUnits='userSpaceOnUse'
            height='150'
            id='Navbar.BG'
            width='260'
            x='4'
            y='0'
          >
            <feOffset dy='5' />
            <feGaussianBlur result='blur' stdDeviation='5' />
            <feFlood floodColor='#12b2a7' floodOpacity='0.4' />
            <feComposite in2='blur' operator='in' />
            <feComposite in='SourceGraphic' />
          </filter>
        </defs>
        <g
          data-name='Group 11053'
          id='Group_11053'
          transform='translate(19540 -17227)'
        >
          <rect
            data-name='Navbar.BG'
            fill='#12b2a7'
            height='82'
            id='Navbar.BG-2'
            opacity='0.35'
            rx='8'
            transform='translate(-19540 17256)'
            width='270'
          />
          <rect
            data-name='Navbar.BG'
            fill='#12b2a7'
            height='100'
            id='Navbar.BG-3'
            opacity='0.35'
            rx='8'
            transform='translate(-19530 17247)'
            width='250'
          />
          <g
            data-name='Group 11052'
            id='Group_11052'
            transform='translate(-20783 15610)'
          >
            <g
              filter='url(#Navbar.BG)'
              transform='matrix(1, 0, 0, 1, 1243, 1617)'
            >
              <rect
                data-name='Navbar.BG'
                fill='#12b2a7'
                height='120'
                id='Navbar.BG-4'
                rx='8'
                transform='translate(19 10)'
                width='230'
              />
            </g>
            <g
              data-name='Path 5238'
              fill='rgba(255,255,255,0.3)'
              id='Path_5238'
              opacity='0.5'
              transform='translate(-16428 17947)'
            >
              <path
                d='M17894.031-16200v-35a8,8,0,0,1,8-8H17920v35a8,8,0,0,1-8,8Zm-38,0v-85a8,8,0,0,1,8-8h18a8,8,0,0,1,8,8v85Zm-38,0v-52a8,8,0,0,1,8-8h18a8,8,0,0,1,8,8v52Z'
                stroke='none'
              />
              <path
                d='M 17912 -16201 C 17915.859375 -16201 17919 -16204.140625 17919 -16208 L 17919 -16242.0009765625 L 17902.03125 -16242.0009765625 C 17898.171875 -16242.0009765625 17895.03125 -16238.8583984375 17895.03125 -16234.99609375 L 17895.03125 -16201 L 17912 -16201 M 17889.025390625 -16201 L 17889.025390625 -16285.001953125 C 17889.025390625 -16288.861328125 17885.884765625 -16292.001953125 17882.025390625 -16292.001953125 L 17864.029296875 -16292.001953125 C 17860.169921875 -16292.001953125 17857.029296875 -16288.861328125 17857.029296875 -16285.001953125 L 17857.029296875 -16201 L 17889.025390625 -16201 M 17851.029296875 -16201 L 17851.029296875 -16251.9990234375 C 17851.029296875 -16255.8583984375 17847.888671875 -16258.9990234375 17844.029296875 -16258.9990234375 L 17826.03125 -16258.9990234375 C 17822.169921875 -16258.9990234375 17819.02734375 -16255.8583984375 17819.02734375 -16251.9990234375 L 17819.02734375 -16201 L 17851.029296875 -16201 M 17912 -16200 L 17894.03125 -16200 L 17894.03125 -16234.99609375 C 17894.03125 -16239.4150390625 17897.611328125 -16243.0009765625 17902.03125 -16243.0009765625 L 17920 -16243.0009765625 L 17920 -16208 C 17920 -16203.58203125 17916.419921875 -16200 17912 -16200 Z M 17890.025390625 -16200 L 17856.029296875 -16200 L 17856.029296875 -16285.001953125 C 17856.029296875 -16289.416015625 17859.611328125 -16293.001953125 17864.029296875 -16293.001953125 L 17882.025390625 -16293.001953125 C 17886.4453125 -16293.001953125 17890.025390625 -16289.416015625 17890.025390625 -16285.001953125 L 17890.025390625 -16200 Z M 17852.029296875 -16200 L 17818.02734375 -16200 L 17818.02734375 -16251.9990234375 C 17818.02734375 -16256.41796875 17821.61328125 -16259.9990234375 17826.03125 -16259.9990234375 L 17844.029296875 -16259.9990234375 C 17848.447265625 -16259.9990234375 17852.029296875 -16256.41796875 17852.029296875 -16251.9990234375 L 17852.029296875 -16200 Z'
                fill='rgba(255,255,255,0.5)'
                stroke='none'
              />
            </g>
            <text
              fill='#fff'
              fontFamily='SourceSansPro-Regular, Source Sans Pro'
              fontSize='14'
              id='IDR'
              transform='translate(1255.973 1673.758)'
            >
              <tspan x='15' y='15'>
                IDR
              </tspan>
            </text>
            <path
              d='M11.444,0h7.112A11.477,11.477,0,0,1,30,11.444v7.112A11.477,11.477,0,0,1,18.556,30H11.444A11.477,11.477,0,0,1,0,18.556V11.444A11.477,11.477,0,0,1,11.444,0ZM20.8,16.939l2.514,1.168a.492.492,0,0,1,.24.653.486.486,0,0,1-.24.24l-8.1,3.761a.5.5,0,0,1-.413,0L6.692,19a.492.492,0,0,1,0-.893l2.514-1.168L6.692,15.772a.492.492,0,0,1,0-.893l7.089-3.29v1.086l-5.711,2.65L15,18.542l6.933-3.217-.569-.263,1.19-.535.757.351a.492.492,0,0,1,.24.653.486.486,0,0,1-.24.24L20.8,16.939ZM15.881,7.191h5.566a1.268,1.268,0,0,1,1.265,1.265v4.217a1.268,1.268,0,0,1-1.265,1.265H16.538l-1.92,1.022v-6.5a1.268,1.268,0,0,1,1.265-1.265ZM18.166,10.2h1.081a.759.759,0,0,1,.755.755v.5a.759.759,0,0,1-.755.755h-.163v.447a.422.422,0,1,1-.843,0V12.21h-.5a.422.422,0,0,1,0-.843h1.415v-.326H18.078a.747.747,0,0,1-.533-.222.76.76,0,0,1-.222-.533v-.5a.763.763,0,0,1,.755-.755h.163V8.581a.422.422,0,0,1,.843,0v.447h.5a.422.422,0,1,1,0,.843H18.166V10.2Z'
              data-name='Path 5239'
              fill='#fff'
              fillRule='evenodd'
              id='Path_5239'
              transform='translate(1452 1637)'
            />
          </g>
        </g>
      </svg>
      <div className='feature-griana LandPrice--sidebar_content'>
        {props.value} <span>/Sqm</span>
      </div>
    </div>
  );
};

const LandPriceDashboard = (props) => {
  return (
    <div className='feature-griana LandPrice--dashboard'>
      <LandPriceIcon height='9rem' width='15rem' />
      <div className='feature-griana LandPrice--dashboard_card'>
        <svg height='9.375rem' viewBox='0 0 260 150' width='16.875rem'>
          <defs>
            <filter
              filterUnits='userSpaceOnUse'
              height='150'
              id='Navbar.BG'
              width='260'
              x='0'
              y='0'
            >
              <feOffset dy='5' />
              <feGaussianBlur result='blur' stdDeviation='5' />
              <feFlood floodColor='#12b2a7' floodOpacity='0.4' />
              <feComposite in2='blur' operator='in' />
              <feComposite in='SourceGraphic' />
            </filter>
          </defs>
          <g
            data-name='Group 11046'
            id='Group_11046'
            transform='translate(-1247 -1612)'
          >
            <g
              data-name='Group 11034'
              id='Group_11034'
              transform='translate(0 -5)'
            >
              <g
                filter='url(#Navbar.BG)'
                transform='matrix(1, 0, 0, 1, 1247, 1617)'
              >
                <rect
                  data-name='Navbar.BG'
                  fill='#12b2a7'
                  height='120'
                  id='Navbar.BG-2'
                  rx='8'
                  transform='translate(15 10)'
                  width='230'
                />
              </g>
              <g
                data-name='Path 5238'
                fill='rgba(255,255,255,0.3)'
                id='Path_5238'
                opacity='0.5'
                transform='translate(-16428 17947)'
              >
                <path
                  d='M17894.031-16200v-35a8,8,0,0,1,8-8H17920v35a8,8,0,0,1-8,8Zm-38,0v-85a8,8,0,0,1,8-8h18a8,8,0,0,1,8,8v85Zm-38,0v-52a8,8,0,0,1,8-8h18a8,8,0,0,1,8,8v52Z'
                  stroke='none'
                />
                <path
                  d='M 17912 -16201 C 17915.859375 -16201 17919 -16204.140625 17919 -16208 L 17919 -16242.0009765625 L 17902.03125 -16242.0009765625 C 17898.171875 -16242.0009765625 17895.03125 -16238.8583984375 17895.03125 -16234.99609375 L 17895.03125 -16201 L 17912 -16201 M 17889.025390625 -16201 L 17889.025390625 -16285.001953125 C 17889.025390625 -16288.861328125 17885.884765625 -16292.001953125 17882.025390625 -16292.001953125 L 17864.029296875 -16292.001953125 C 17860.169921875 -16292.001953125 17857.029296875 -16288.861328125 17857.029296875 -16285.001953125 L 17857.029296875 -16201 L 17889.025390625 -16201 M 17851.029296875 -16201 L 17851.029296875 -16251.9990234375 C 17851.029296875 -16255.8583984375 17847.888671875 -16258.9990234375 17844.029296875 -16258.9990234375 L 17826.03125 -16258.9990234375 C 17822.169921875 -16258.9990234375 17819.02734375 -16255.8583984375 17819.02734375 -16251.9990234375 L 17819.02734375 -16201 L 17851.029296875 -16201 M 17912 -16200 L 17894.03125 -16200 L 17894.03125 -16234.99609375 C 17894.03125 -16239.4150390625 17897.611328125 -16243.0009765625 17902.03125 -16243.0009765625 L 17920 -16243.0009765625 L 17920 -16208 C 17920 -16203.58203125 17916.419921875 -16200 17912 -16200 Z M 17890.025390625 -16200 L 17856.029296875 -16200 L 17856.029296875 -16285.001953125 C 17856.029296875 -16289.416015625 17859.611328125 -16293.001953125 17864.029296875 -16293.001953125 L 17882.025390625 -16293.001953125 C 17886.4453125 -16293.001953125 17890.025390625 -16289.416015625 17890.025390625 -16285.001953125 L 17890.025390625 -16200 Z M 17852.029296875 -16200 L 17818.02734375 -16200 L 17818.02734375 -16251.9990234375 C 17818.02734375 -16256.41796875 17821.61328125 -16259.9990234375 17826.03125 -16259.9990234375 L 17844.029296875 -16259.9990234375 C 17848.447265625 -16259.9990234375 17852.029296875 -16256.41796875 17852.029296875 -16251.9990234375 L 17852.029296875 -16200 Z'
                  fill='rgba(255,255,255,0.5)'
                  stroke='none'
                />
              </g>
              <g
                data-name='Group 11033'
                id='Group_11033'
                transform='translate(26.027 15.242)'
              >
                <text
                  fill='#fff'
                  fontFamily='SourceSansPro-Regular, Source Sans Pro'
                  fontSize='14'
                  id='IDR'
                  transform='translate(1255.973 1673.758)'
                >
                  <tspan x='-10.143' y='0'>
                    IDR
                  </tspan>
                </text>
              </g>
              <path
                d='M11.444,0h7.112A11.477,11.477,0,0,1,30,11.444v7.112A11.477,11.477,0,0,1,18.556,30H11.444A11.477,11.477,0,0,1,0,18.556V11.444A11.477,11.477,0,0,1,11.444,0ZM20.8,16.939l2.514,1.168a.492.492,0,0,1,.24.653.486.486,0,0,1-.24.24l-8.1,3.761a.5.5,0,0,1-.413,0L6.692,19a.492.492,0,0,1,0-.893l2.514-1.168L6.692,15.772a.492.492,0,0,1,0-.893l7.089-3.29v1.086l-5.711,2.65L15,18.542l6.933-3.217-.569-.263,1.19-.535.757.351a.492.492,0,0,1,.24.653.486.486,0,0,1-.24.24L20.8,16.939ZM15.881,7.191h5.566a1.268,1.268,0,0,1,1.265,1.265v4.217a1.268,1.268,0,0,1-1.265,1.265H16.538l-1.92,1.022v-6.5a1.268,1.268,0,0,1,1.265-1.265ZM18.166,10.2h1.081a.759.759,0,0,1,.755.755v.5a.759.759,0,0,1-.755.755h-.163v.447a.422.422,0,1,1-.843,0V12.21h-.5a.422.422,0,0,1,0-.843h1.415v-.326H18.078a.747.747,0,0,1-.533-.222.76.76,0,0,1-.222-.533v-.5a.763.763,0,0,1,.755-.755h.163V8.581a.422.422,0,0,1,.843,0v.447h.5a.422.422,0,1,1,0,.843H18.166V10.2Z'
                data-name='Path 5239'
                fill='#fff'
                fillRule='evenodd'
                id='Path_5239'
                transform='translate(1452 1637)'
              />
            </g>
            <g
              data-name='Group 11045'
              id='Group_11045'
              transform='translate(897 498.002)'
            >
              <path
                d='M17890-16182h-170a8.01,8.01,0,0,1-8-8v-10h186v10A8.01,8.01,0,0,1,17890-16182Z'
                data-name='Subtraction 73'
                fill='#12b2a7'
                id='Subtraction_73'
                opacity='0.35'
                transform='translate(-17325 17444)'
              />
              <path
                d='M17904-16191h-198a8.01,8.01,0,0,1-8-8v-1h214v1A8.01,8.01,0,0,1,17904-16191Z'
                data-name='Subtraction 72'
                fill='#12b2a7'
                id='Subtraction_72'
                opacity='0.35'
                transform='translate(-17325 17444)'
              />
            </g>
          </g>
        </svg>
        <div className='feature-griana LandPrice--dashboard_content'>
          {props.value} <span>/Sqm</span>
        </div>
      </div>
    </div>
  );
};

/**
 *
 * @param {object} props
 * @param {'sidebar' | 'dashboard'} props.type
 * @param {string} props.value
 * @param {string} props.title
 */
export default function LandPrice(props) {
  return (
    <div id={props.id} style={props?.style}>
      <BaseCard
        isLoading={props?.isLoading}
        title={props.title || 'Average land price'}
        withPadding={true}
      >
        <div className='feature-griana LandPrice'>
          <div>The selling value of land will always change every year</div>
          {props.type === 'sidebar' ? (
            <LandPriceSidebar value={props.value} />
          ) : (
            <LandPriceDashboard value={props.value} />
          )}
        </div>
      </BaseCard>
    </div>
  );
}

LandPrice.defaultProps = {
  type: 'sidebar',
  value: '999.999.999',
};

LandPrice.propTypes = {
  type: PropTypes.oneOf(['sidebar', 'dashboard']),
  value: PropTypes.string,
};

LandPriceSidebar.propTypes = {
  value: PropTypes.string,
};

LandPriceDashboard.propTypes = {
  value: PropTypes.string,
};
